import { render, staticRenderFns } from "./DesktopMenu.vue?vue&type=template&id=502e6fcb&scoped=true&"
import script from "./DesktopMenu.vue?vue&type=script&lang=js&"
export * from "./DesktopMenu.vue?vue&type=script&lang=js&"
import style0 from "./DesktopMenu.vue?vue&type=style&index=0&id=502e6fcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502e6fcb",
  null
  
)

export default component.exports